import axios from "axios";
import {
  CUSTOMERS_URL,
  PRESIGNED_URL,
  GET_STATE_URL,
  GET_COUNTY_URL,
  ORDER_URL,
  GET_CITY_URL,
  CUSTOMER_REPORT,
  GP_GET_BANK_DETAIL_CUST,
  CUSTOMER_CSV_URL,
  CUSTOMER_LEDGER_PDF_URL,
  CONSENT_CUSTOMER,
  CUSTOM_COUNTIES_URL,
  CUSTOM_CITIES_URL,
  CUSTOM_CITY_URL,
  CUSTOM_COUNTY_URL,
  GP_GET_BANK_DETAIL_SUPL,
  APPROVE_REJECT_CUSTOMER_LEAD,
  APPLY_BULK_ACTIONS_URL,
  GP_BANK_BALANCE,
  CUSTOMER_BALANCE_ADJUSTMENT_URL,
  ACTIVITY_LOGS_NEW,
  SEND_CUSTOMER_INVOICE_EMAIL,
  CUSTOMER_LOGS_EXPORT_URL,
  PAYMENT_COLLECTION_URL,
} from "../../../../../constants/config";

//call api to fetch customers
export function findCustomers(queryParams) {
  const expiredLicense = queryParams?.expired_license ? queryParams.expired_license.replace(/%20/g, " ") : "";
  return axios.get(
    `${CUSTOMERS_URL}/list2?search_key=${queryParams?.searchKey || ""}&customer_type=${queryParams?.customer_type || ""}&show_customer_groups=${queryParams?.show_customer_groups || ""}&allow_ecom=${queryParams?.allowEcom || ""}&sale_agent_ids=${queryParams?.sale_agent_ids || []}&customer_group_ids=${queryParams?.customer_group_ids || []}&on_account_min=${queryParams?.searchOnAccount || ""}&is_active=${queryParams?.is_active ?? 1}&page=${queryParams.pageNumber || 1}&created_at_start=${queryParams?.created_at_start || ""}&created_at_end=${queryParams?.created_at_end || ""}&page_size=${queryParams.pageSize || 20}&sort_by=${queryParams.sort_by || "id:desc"}&expired_license=${expiredLicense}&is_exempt_from_tax=${queryParams?.is_exempt_from_tax || ""}&tier_ids=${queryParams?.tier_id || ""}&class_of_trades=${queryParams?.class_of_trades || ""}&state=${encodeURIComponent(queryParams?.state || "")}&city=${encodeURIComponent(queryParams?.city || "")}&county=${encodeURIComponent(queryParams?.county || "")}&waiting_for_approval=${queryParams?.waiting_for_approval || ""}`
  );
}

export function findCustomersOptimizedList(params) {
  return axios.get(`${CUSTOMERS_URL}/list2`, params);
}

export function findCustomerByBusinessName(queryParams) {
  return axios.get(`${CUSTOMERS_URL}/list2?search_name_business_name=${queryParams}`);
}

export function findCustomerById(Id) {
  return axios.get(`${CUSTOMERS_URL}/${Id}`);
}
export function findCustomerByEmail(queryParams) {
  return axios.get(`${CUSTOMERS_URL}/list2?search_email_address_phone=${queryParams}`);
}

export function reChargeSaleOrder(payload) {
  return axios.post(`${ORDER_URL}/bulk_inv_pay`, { ...payload });
}
export function reChargeCustomer(payload) {
  return axios.post(`${CUSTOMERS_URL}/recharge`, { ...payload });
}

export function findCustomersOptimized(params) {
  return axios.get(`${CUSTOMERS_URL}/${params.id}`);
}
export function bankDetail(customer_id) {
  return axios.get(`${GP_GET_BANK_DETAIL_CUST}/${customer_id}`);
}
export function bankListDetail(customer_id) {
  return axios.get(`${GP_GET_BANK_DETAIL_CUST}/list?customer_id=${customer_id}`);
}
export function getBalanceCustomerAccount(customer_id, customer_uuid) {
  return axios.get(`${GP_BANK_BALANCE}/${customer_id}/${customer_uuid}`);
}

export function setDefaultBank(customer_id, payload) {
  return axios.patch(`${GP_GET_BANK_DETAIL_CUST}/${customer_id}`, payload);
}
export function bankDetailAch(For = "customer", id) {
  if (For.toLowerCase() == "customer") {
    return axios.get(`${GP_GET_BANK_DETAIL_CUST}/${id}`);
  } else {
    return axios.get(`${GP_GET_BANK_DETAIL_SUPL}/${id}`);
  }
}
export function consentCustomer(payload) {
  return axios.post(`${CONSENT_CUSTOMER}`, { ...payload });
}

export function achConsent(For = "customer", payload) {
  if (For.toLowerCase() == "customer") {
    return axios.post(`${CONSENT_CUSTOMER}`, { ...payload });
  } else {
    return axios.post(`${GP_GET_BANK_DETAIL_SUPL}`, { ...payload });
  }
}
export const impersonate = (customer_id, cb, cbForError) => {
  return axios
    .post(`${CUSTOMERS_URL}/impersonate-user`, { customer_id })
    .then(({ data }) => {
      cb(data);
    })
    .catch((err) => {
      cbForError(err);
    });
};
export function generateNumbers() {
  return axios.get(`${CUSTOMERS_URL}/generate-numbers`);
}
export function getSingleCustomer(Id) {
  return axios.get(`${CUSTOMERS_URL}/${Id}`);
}
export function createCustomer(customer) {
  return axios.post(`${CUSTOMERS_URL}`, customer);
}

export function singleCustomer(id) {
  return axios.get(`${CUSTOMERS_URL}/${id}`);
}

export function updateCustomer(customer, customerId) {
  return axios.put(`${CUSTOMERS_URL}/${customerId}`, customer);
}
export function updateCustomerLicense(license, customerId) {
  return axios.patch(`${CUSTOMERS_URL}/${customerId}`, license);
}
export function generatePresignedUrls(keys) {
  return axios.post(PRESIGNED_URL, keys);
}
export function deleteCustomer(id) {
  return axios.delete(`${CUSTOMERS_URL}/${id}`);
}
export function activateCustomer(id, payload) {
  return axios.patch(`${CUSTOMERS_URL}/active-customer/${id}`, payload);
}
export function uploadToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}
export function sendCustomerExpiryEmail(id) {
  return axios.post(`${CUSTOMERS_URL}/${id}/email`);
}
export function recharge(payload) {
  return axios.post(`${CUSTOMERS_URL}/recharge`, { ...payload });
}
export function adjustBalance(id, payload) {
  return axios.put(`${CUSTOMERS_URL}/${id}/adjust/balance`, { ...payload });
}
export function getStates(params) {
  return axios.get(`${GET_STATE_URL}`, { params });
}

export function getCounty(params) {
  return axios.get(`${GET_COUNTY_URL}`, { params });
}

export function getCities(params) {
  return axios.get(`${GET_CITY_URL}`, { params });
}

export function getPresignedUrl(key) {
  key = key.replaceAll(" ", "-");
  return axios.post(PRESIGNED_URL, [{ key: key }]);
}

export function uploadFileToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}

export function checkExportApiStatus(payload) {
  return axios.post(`${CUSTOMER_REPORT}`, payload);
}

export function customerBulkCreate(s3_key) {
  return axios.post(`${CUSTOMERS_URL}/import`, { s3_key });
}
export function getDraftInvoicesList(payload) {
  return axios.post(`${ORDER_URL}/bulk_post_invoice`, payload);
}

export function getLedgerInfo(params) {
  return axios.get(
    `${ORDER_URL}/list2?orderNo=${params.orderNo || ""}&sale_order_no=${params.sale_order_no || ""}&customerIds=${params.customerIds || ""}&invoice_statuses=${params.invoice_statuses}&page_size=${params.pageSize}&page=${params.pageNumber}&startDate=${params.startDate}&endDate=${params.endDate}&sort_by=due_date:asc&include_ledger_metrics=true&exclude_adjustment=${params.exclude_adjustment}${params.exclude_ids?"&exclude_ids="+params.exclude_ids:""}`
  );
}

export function getLedgerStats(params) {
  return axios.get(`${ORDER_URL}/list2?include_ledger_metrics=true&exclude_adjustment=0&customerIds=${params.customerIds}`);
}
export function getcustomerPurchasingStats(params) {
  const { customerIds, ...filters } = params;

  return axios.get(`${CUSTOMERS_URL}/customer_purchase_history`, {
    params: {
      customer_id: customerIds,
      ...filters,
    },
  });
}

export function printLedger(params) {
  return axios.get(`${ORDER_URL}/ledger-pdf`, { params });
}

export function printCustomerLedgerPdf(params) {
  return axios.get(`${CUSTOMER_LEDGER_PDF_URL}/ledger-pdf`, { params });
}

export function printCustomerLedgerCsv(params) {
  return axios.get(`${CUSTOMER_CSV_URL}/ledger-csv`, { params });
}

export function customerledgerEmail(payload) {
  const { id, ...restPayload } = payload;
  return axios.post(`${CUSTOMERS_URL}/${id}`, restPayload);
}

// Custom Cities & Counties
export function getCustomCities(params) {
  return axios.get(`${CUSTOM_CITIES_URL}`, { params });
}

export function getCustomCounties(params) {
  return axios.get(`${CUSTOM_COUNTIES_URL}`, { params });
}

export function addCustomCity(payload) {
  return axios.post(`${CUSTOM_CITY_URL}`, { ...payload });
}

export function addCustomCounty(payload) {
  return axios.post(`${CUSTOM_COUNTY_URL}`, { ...payload });
}

export function updateCustomCity(payload) {
  const { id } = payload;
  return axios.put(`${CUSTOM_CITY_URL}/${id}`, { ...payload });
}

export function updateCustomCounty(payload) {
  const { id } = payload;
  return axios.put(`${CUSTOM_COUNTY_URL}/${id}`, { ...payload });
}

// Get All Customer Leads
// page_size=-1 asks the backend for every matching row instead of one fixed
// page (this used to be hard-coded to page_size=20, which silently hid any
// pending requests beyond the first 20).
export function getAllCustomerLeads() {
  return findCustomers({ is_active: -1, waiting_for_approval: "Y", pageSize: -1, sort_by: "id:desc" });
}

// Approve or reject Customer Lead

export function approveRejectCustomerLead(payload, id) {
  return axios.patch(`${APPROVE_REJECT_CUSTOMER_LEAD}/${id}`, { ...payload });
}

// Bulk Actions

export function applyBulkActions(payload) {
  return axios.post(`${APPLY_BULK_ACTIONS_URL}`, payload);
}

// Balance Adjustment
export function createBalanceAdjustment(payload) {
  return axios.post(`${CUSTOMER_BALANCE_ADJUSTMENT_URL}`, payload);
}

export function getCustomerBalanceAdjustment(id) {
  return axios.get(`${CUSTOMER_BALANCE_ADJUSTMENT_URL}/${id}`);
}

export function voidCustomerBalanceAdjustment(id) {
  return axios.post(`${CUSTOMER_BALANCE_ADJUSTMENT_URL}/${id}/void`);
}

export function sendCustomerInvoicesEmail(payload) {
  return axios.post(`${SEND_CUSTOMER_INVOICE_EMAIL}`, payload);
}

export function fetchCustomerActivityLog(queryparams) {
  return axios.get(`${ACTIVITY_LOGS_NEW}?table_name=customers&entity_id=${queryparams}&sort_by=created_at:desc`);
}
export function checkCustomerActivityLogExport(customer_id, savedValues) {
  return axios.post(`${CUSTOMER_LOGS_EXPORT_URL}?start_date=${savedValues.start_date}&end_date=${savedValues.end_date}&customer_id=${customer_id}`);
}

// payload: { reset_password: boolean, new_password?: string }
// reset_password=false -> details-only email (public key + username).
// reset_password=true  -> also updates the customer's ecom password and includes it in the email.
export function sendKonnectConnectionEmail(customerId, payload) {
  return axios.post(`${CUSTOMERS_URL}/${customerId}/konnect-connection-email`, payload);
}

// Driver-collected payments (cash/cheque collected in the field, awaiting admin review)
export function findPaymentCollections(params) {
  return axios.get(`${PAYMENT_COLLECTION_URL}/list`, { params });
}

export function approvePaymentCollection(id) {
  return axios.post(`${PAYMENT_COLLECTION_URL}/${id}/approve`);
}

export function rejectPaymentCollection(id, rejection_reason) {
  return axios.post(`${PAYMENT_COLLECTION_URL}/${id}/reject`, { rejection_reason });
}
